///live
// export const BASE_URL = "http://admin.redsea-market.com/api";
// export const IMAGE_URL = "http://admin.redsea-market.com";

///live demo
export const BASE_URL = "https://redsea-backend.prompttechdemohosting.com/api";
export const IMAGE_URL = "https://redsea-backend.prompttechdemohosting.com/";

///local
// export const BASE_URL = "https://jamal-al-bahr-backend.test/api";
// export const IMAGE_URL = "https://jamal-al-bahr-backend.test";

export const GOOGLEMAPS_API = "AIzaSyAEysollDCaGfbiPxh-VBvv31u2msCwa1c";

// export const public_key = 'pk_test_51HqJ58APs1IO5yfEfBSAuoe8rzKF7WM0FGXRU9mz8COOALGdACLE3zTodNT2OJnXlrgJl7nyFrxSdXILI8izGRsn00lMnBCHSK';
// export const secret_key = 'sk_test_51HqJ58APs1IO5yfE3dtoHFXSEfscNwttjD3MFe4Qcu3ir2NhLbrr7HhMhUcYs1NhkVb91LZI9ecYsurUfcslXBDp00NYFzKvjF';

export const public_key =
  "pk_test_51Mt2sYBMW2pHNbgOU9c00hwrw11tJhR7u0ulNDF4fLEW2C6lYJEG1w3xennVSAGPC9mhbvTlBqmB3bdsoVcO8ogR007fWhRn6G";
export const secret_key =
  "sk_test_51Mt2sYBMW2pHNbgO03YUbRusadpTK3kaTvlD8HH0yG1SCc6w8UHnZXSdH5tiiPEfKDPDP7OVg8r0izz2KwLUQ84I00IkCJVzWB";

export const userToken = localStorage.getItem("userToken")
  ? localStorage.getItem("userToken")
  : null;
